<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Cadastro de URLs.</span>
                <br />
                <span class="navigation">Cadastros > URL</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-2 mb-2">
              <label for="tipo">Tipo:</label>
              <span class="p-fluid">
                <Dropdown id="tipo" v-model="selectedTipo" :options="tipos" optionLabel="name"
                  placeholder="Selecione um Tipo" @change="onTipoChange" />
              </span>
            </div>

            <div class="col-md-4 mb-2">
              <label for="filtro">Filtro:</label>
              <span class="p-fluid">
                <InputText type="text" id="filtro" v-model="filtro" />
              </span>
            </div>
            <div class="mb-2">
              <label for="btnSearch">&nbsp;</label>
              <span class="p-fluid">
                <Button label="Pesquisar" title="Pesquisar" icon="pi pi-search" :disabled="search"
                  @click="pesquisar()" />
              </span>
            </div>
            <div class="mb-2" style="padding-left:2px">
              <label for="btnSearch">&nbsp;</label>
              <span class="p-fluid">
                <Button label="Limpar Filtros" title="Limpar" icon="pi pi-trash" :disabled="search" @click="clear()" />
              </span>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <DataTable :value="urlList" responsiveLayout="scroll" class="p-datatable-gridlines" :paginator="true"
                :rows="10">
                <Column headerStyle="width: 8em" bodyStyle="text-align: center">
                  <template #body="slotProps">
                    <Button type="button" icon="pi pi-pencil" style="margin-right: .5em"
                      @click="detail(slotProps.data.id)"></Button>
                    <Button type="button" icon="pi pi-trash" @click="confirmRemove(slotProps.data.id)"></Button>
                  </template>
                </Column>
                <Column field="menu" header="Nome" headerStyle="width: 15em"></Column>
                <Column field="idPaginaPai.menu" header="Menu" headerStyle="width: 15em"></Column>
                <Column header="Perfis" headerStyle="width: 30em">
                  <template #body="slotProps">
                    <ul>
                      <li v-for="perfil in slotProps.data.perfis" :key="perfil.id">{{ perfil.nome }}</li>
                    </ul>
                  </template>
                </Column>
                <Column field="url" header="URL"></Column>
              </DataTable>
            </div>
          </div>

          <hr />

          <div class="row">
            <span class="p-fluid mr-2">
              <router-link to="/urlCadastro">
                <Button type="button" icon="pi pi-plus" label="Novo" title="Novo" />
              </router-link>
            </span>
          </div>
        </div>
      </div>
    </div>
    <Dialog header="Aviso" :visible.sync="display" :style="{ width: '30vw' }" :modal="true">
      Confirma a remoção do Registro?
      <template #footer>
        <Button label="Sim" icon="pi pi-check" @click="remove" title="Sim" />
        <Button label="Não" icon="pi pi-times" @click="close" title="Não" class="p-button-secondary" />
      </template>
    </Dialog>
  </div>
</template>
<script>

import LoginService from "../services/acesso/login.service";
import UrlService from "../services/nfse/url.service";

export default {
  name: "url",
  data() {
    return {
      loading: false,
      display: false,
      search: false,
      filtro: "",
      urlList: [],
      urlId: null,
      currentUser: null,
      tipos: [
        { name: 'Menu Principal', key: 'M' },
        { name: 'Item de Menu', key: 'I' }
      ],
      selectedTipo: null,
    };
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    this.selectedTipo = this.tipos[1];
    this.pesquisar();
  },
  methods: {
    clear() {
      this.filtro = "";
      this.pesquisar();
    },
    pesquisar() {
      this.search = true;
      UrlService.findAllByFiltro(
        this.currentUser.usuario.idCliente,
        this.filtro,
        this.selectedTipo.key
      ).then(
        url => {
          this.urlList = url.data;
          console.log(this.urlList);
        },
        error => {
          let errorMessage = "Houve um problema ao listar URLs!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
      this.search = false;
    },
    detail(urlId) {
      this.$router.push({ name: "urlCadastro", params: { id: urlId } });
    },
    confirmRemove(urlId) {
      this.urlId = urlId;
      this.display = true;
    },
    close() {
      this.urlId = null;
      this.display = false;
    },
    remove() {
      UrlService.remove(this.urlId).then(
        data => {
          console.log(data);
          this.$root.$emit("alert:success", "URL removida com sucesso!");
          setTimeout(async () => {
            await this.pesquisar();
            this.display = false;
          }, 250);
        },
        error => {
          let errorMessage = "Houve um problema ao remover a URL!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$root.$emit("alert:error", errorMessage);
          this.close()
        }
      )
    },
    onTipoChange() {
      this.pesquisar();
    }
  }
};
</script>

<style scoped></style>
